/** Project members repository (populated by sync pull). */
import { db, type ProjectMemberRecord } from './db';

export const PROJECT_MEMBER_ENTITY = 'project_member';

export function listMembers(projectId: string): Promise<ProjectMemberRecord[]> {
  return db.project_members.where('project_id').equals(projectId).toArray();
}

export async function applyMemberChange(
  entityId: string,
  op: 'upsert' | 'delete',
  version: number,
  data: Record<string, unknown> | null,
  fallbackProjectId: string,
): Promise<void> {
  if (op === 'delete') {
    await db.project_members.delete(entityId);
    return;
  }
  const incoming = data ?? {};
  await db.project_members.put({
    id: entityId,
    project_id:
      typeof incoming['project_id'] === 'string' ? incoming['project_id'] : fallbackProjectId,
    user_id: typeof incoming['user_id'] === 'string' ? incoming['user_id'] : null,
    data: incoming,
    version,
  });
}
